import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import algoliasearch from "algoliasearch";

const client = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_ADMIN_KEY
);
const indexShoppingList = client.initIndex("shoppingList"); // Name of index in Algolia is shoppingList
const indexUsers = client.initIndex("users"); // Name of index in Algolia is users

export const saveShoppingListToAlgolia = async (user, listId) => {
  console.log("algolia save user", user);
  console.log("algolia save listId", listId);
  try {
    const shoppingListRef = doc(
      db,
      "users",
      user?.uid || user?.id,
      "shoppingList",
      listId
    );
    try {
      const shoppingListDoc = await getDoc(shoppingListRef);
      const shoppingList = shoppingListDoc.data();
      const dateCreated =
        shoppingList?.dateCreated?.seconds || new Date().getTime() / 1000;
      const lastUpdated =
        shoppingList?.lastUpdated?.seconds || new Date().getTime() / 1000;

      let shopListData = {
        objectID: shoppingList?.listId,
        id: shoppingListDoc.id,
        dateCreated,
        lastUpdated,
        listId: shoppingList?.listId,
        listName: shoppingList?.listName,
        sizes: shoppingList?.sizes,
        visibility: shoppingList?.visibility,
        ownerId: user?.uid || user?.id,
      };
      await indexShoppingList.saveObject(shopListData);
      // return shopListData;
    } catch (error) {
      console.error("Error setting up snapshot listener:", error);
    }
  } catch (error) {
    console.error(error);
  }
};
export const deleteShoppingListFromAlgolia = async (listId) => {
  try {
    console.log("algolia delete listId", listId);
    await indexShoppingList.deleteObject(listId);
  } catch (error) {
    console.error(error);
  }
};

export const uploadAllUsersToAlgolia = async () => {
  try {
    const userSnapshot = collection(db, "users");
    const querySnapshot = await getDocs(userSnapshot);
    const users = [];
    await Promise.all(
      querySnapshot.docs.map((doc) => {
        const data = doc?.data();
        users.push({
          objectID: doc?.id,
          email: data?.email || null,
          objectUser: data,
          displayName: data?.userName || null,
        });
      })
    );
    await indexUsers.saveObjects(users);
    console.log("users uploaded successfully");
  } catch (error) {
    console.error(error);
  }
};

export const uploadAllShoppingListToAlgolia = async () => {
  try {
    const userSnapshot = collection(db, "users");
    const querySnapshot = await getDocs(userSnapshot);
    // Fetch all users
    const users = querySnapshot.docs.map((doc) => doc?.id);
    //Iterate through every user
    await Promise.all(
      users.map(async (user) => {
        //Find the shopping lists of each user
        const shoppingListSnapshot = collection(
          db,
          "users",
          user,
          "shoppingList"
        );
        const shoppingListData = await getDocs(shoppingListSnapshot);
        // Iterate through every shopping list
        await Promise.all(
          shoppingListData.docs.map(async (shoppingListDoc) => {
            const shoppingList = shoppingListDoc?.data();
            if (shoppingList?.visibility !== "Public") return;
            const dateCreated =
              shoppingList?.dateCreated?.seconds || new Date().getTime() / 1000;
            const lastUpdated =
              shoppingList?.lastUpdated?.seconds || new Date().getTime() / 1000;
            let shopListData = {
              objectID: shoppingList?.listId,
              id: shoppingListDoc?.id,
              dateCreated,
              lastUpdated,
              listId: shoppingList?.listId,
              listName: shoppingList?.listName,
              sizes: shoppingList?.sizes,
              visibility: shoppingList?.visibility,
              ownerId: user?.uid || user?.id,
            };
            await indexShoppingList.saveObject(shopListData);
            console.log(
              "shopping list uploaded successfully",
              user,
              shoppingListDoc?.id
            );
          })
        );
      })
    );
    console.log("shopping lists uploaded successfully");
  } catch (error) {
    console.error(error);
  }
};
